module.exports = __webpack_public_path__ + "static/media/U1-T1-08A_R.96ec7960.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-08A_R.svg
// module id = 584
// module chunks = 0